import React, { useEffect, Fragment, useCallback, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import menuService from "../../services/menu";
import AuthService from "../../services/security/auth.service";
import TokenService from "../../services/security/token.service";
import { styled, useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import Autocomplete from '@mui/material/Autocomplete';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import StarBorder from '@mui/icons-material/StarBorder';
import AddIcon from '@mui/icons-material/Add';
import AccountCircle from '@mui/icons-material/AccountCircle';
import CircularProgress from '@mui/material/CircularProgress';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import Logout from '@mui/icons-material/Logout';
import Settings from '@mui/icons-material/Settings';
import Avatar from '@mui/material/Avatar';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import constants from "../../utils/constants";
import Icons from "../Icons";
import informationService from '../../services/system';
import docsService from "../../services/docs";
import rolesService from "../../services/roles"
import _ from 'lodash';

const drawerWidth = 240;
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('xs')]: {
        width: '8ch',  // Full width for extra small screens
    },
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(3),
        width: 'auto',  // Auto width for small screens and up
    },
    [theme.breakpoints.up('md')]: {
        width: '30ch',  // Specific width for medium screens and up
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    //padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
        fontSize: '24px', // Tamaño del ícono por defecto
        [theme.breakpoints.down('xs')]: {
            fontSize: '14px', // Tamaño reducido para pantallas xs
            width: '10px',
            //padding: theme.spacing(0, 1),
        },
    },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(1)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('xs')]: {
            '&::placeholder': {
                color: 'transparent',  // Hide placeholder in xs screens
            },
        },
        [theme.breakpoints.up('sm')]: {
            '&::placeholder': {
                color: 'inherit',  // Show placeholder in sm screens and above
            },
            width: '16ch',  // Adjust width for small screens
        },
        [theme.breakpoints.up('md')]: {
            width: '20ch',  // Adjust width for medium screens and above
        },
    },
}));

const ResultsContainer = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    zIndex: 1,
    maxHeight: '600px',
    overflowY: 'auto',
    color: theme.palette.text.primary,
    width: 'auto',
    minWidth: '600px',  // Min-width para pantallas grandes
}));

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontSize: '0.7rem'
}));

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    transition: theme.transitions.create(['margin', 'width'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
}));

const initialDocTitle = (data) => {
    let arrayDocTitle = [];
    for (let d = 0; d < data.length; d++) {
        arrayDocTitle.push({
            doc: data[d].id,
            title: data[d].crud.title,
        })
    }
    return arrayDocTitle;
}

const imageUrl = 'https://storage.googleapis.com/web-winvest/media/';

function PersistentDrawerLeft() {

    const docs = useRef([]);
    const roles = useRef([]);
    const inputRef = useRef(null);
    const path = window.location.pathname;
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [openMenu, setOpenMenu] = React.useState({});
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [currentUser, setCurrentUser] = React.useState({});
    const [menu, setMenu] = React.useState([]);
    const [menuOriginal, setMenuOriginal] = React.useState([]);
    const [optionsComitentes, setOptionsComitentes] = React.useState([]);
    const [validateComitente, setValidateComitente] = React.useState(false);
    const [filterComitente, setFilterComitente] = React.useState(AuthService.getCurrentUser() ?
        (AuthService.getCurrentUser().data.tradeAccountId ?
            {
                id: AuthService.getCurrentUser().data.tradeAccountId,
                label: AuthService.getCurrentUser().data.tradeAccount,
                isInactive: 0,
            } : null
        )
        : null);
    const [inputValueComitente, setInputValueComite] = React.useState('');
    const isMenuOpen = Boolean(anchorEl);
    let navigate = useNavigate();

    const [searchText, setSearchText] = React.useState('');
    const [searchResults, setSearchResults] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isLoad, setIsLoad] = React.useState(false);
    const [isResultsVisible, setIsResultsVisible] = useState(false);
    const [anchorElCuentaComitente, setAnchorElCuentaComitente] = useState(null);

    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (user) {
            docsService.viewDocsFindAll(constants.CLIENT, user.data.instance)
                .then((response) => {
                    docs.current = initialDocTitle(response.data);
                })
                .catch((error) => {
                    console.log(error);
                });

            rolesService.viewRoles(constants.CLIENT, user.data.instance).then((responseRoles) => {
                let arrayRoles = [];
                let menuType = null;
                for (let d = 0; d < responseRoles.data.length; d++) {
                    if (user.data.role === responseRoles.data[d].id) {
                        menuType = responseRoles.data[d].menuType ? responseRoles.data[d].menuType : null;
                        for (let h = 0; h < responseRoles.data[d].docs.length; h++) {
                            arrayRoles.push(responseRoles.data[d].docs[h]);
                        }
                    }
                }
                roles.menuType = menuType;
                roles.current = arrayRoles;
            })
        }
    }, []);

    const handleOpenAndFocus = () => {
        handleDrawerOpen();
        setTimeout(() => {
            inputRef.current?.focus();
        }, 200); // pequeño delay para que el Drawer termine la animación
    };

    const handleClickCuentaComitente = (event) => {
        setAnchorElCuentaComitente(event.currentTarget);
    };

    const handleSelectCuentaComitente = (item, instance) => {

        let dataUser = TokenService.getUser();
        dataUser.data = item;
        dataUser.data.instance = instance;
        TokenService.setUser(dataUser);

        AuthService.addLogin(dataUser.email, dataUser.password, dataUser.data.entityId, constants.CLIENT, dataUser.data.role, dataUser.data.instance, dataUser.data.entityId);

        setAnchorElCuentaComitente(null);

        let landingPage = dataUser.data.landingPage;
        if (landingPage) {
            if (path.includes(landingPage)) {
                window.location.reload();
            } else {
                navigate(`/${landingPage}`);
                window.location.reload();
            }
            //

        }
        else
            navigate(`/home`);

        //window.location.reload();
    };

    const handleInputChangeComitente = (event, newInputValue) => {
        setInputValueComite(newInputValue);
        const filtered = optionsComitentes.filter((option) =>
            option.label.toLowerCase().includes(newInputValue.toLowerCase())
        );
        let dataUser = TokenService.getUser();
        if (filtered.length === 1) {
            setFilterComitente(filtered[0]);

            dataUser.data.tradeAccount = filtered[0].label;
            dataUser.data.tradeAccountId = filtered[0].id;
            TokenService.setUser(dataUser);
            window.location.reload();
        }

        if (filtered.length === 0 && validateComitente) {
            let dataUser = TokenService.getUser();
            dataUser.data.tradeAccount = null;
            dataUser.data.tradeAccountId = null;
            TokenService.setUser(dataUser);
            window.location.reload();
        }
    };

    const handleChangeComitente = (event, newValue) => {
        setFilterComitente(newValue);
        let dataUser = TokenService.getUser();
        dataUser.data.tradeAccount = newValue ? newValue.label : null;
        dataUser.data.tradeAccountId = newValue ? newValue.id : null;
        TokenService.setUser(dataUser);
        window.location.reload();
    };

    const handleCloseCuentaComitente = () => {

        setAnchorElCuentaComitente(null);
    };

    const fetchResults = useCallback(async (inputValue) => {
        if (inputValue.length >= 3) {
            setIsResultsVisible(true);
            setIsLoading(true);
            try {
                const user = AuthService.getCurrentUser();
                let managerId = null;
                let tradeAccountId = null;
                if (user.data.managerId) {
                    managerId = user.data.managerId;
                }
                if (user.data.tradeAccountId) {
                    tradeAccountId = user.data.tradeAccountId;
                }
                let response = await informationService.searchGlobal(constants.CLIENT, user.data.instance, inputValue, managerId, tradeAccountId);

                let arrayResponse = [];
                for (let g = 0; g < response.data.length; g++) {
                    let existeDocRol = false;
                    for (let b = 0; b < roles.current.length; b++) {
                        if (response.data[g].doc === roles.current[b].name)
                            existeDocRol = true;
                    }
                    if (existeDocRol) {
                        let existeDoc = false;
                        for (let b = 0; b < docs.current.length; b++) {
                            if (docs.current[b].doc === response.data[g].doc) {
                                response.data[g].title = docs.current[b].title;
                                existeDoc = true;
                            }
                        }
                        if (existeDoc)
                            arrayResponse.push(response.data[g]);
                    }
                }
                setSearchResults(arrayResponse);
            } catch (error) {
                console.error('Error al obtener resultados de la búsqueda:', error);
            } finally {
                setIsLoading(false);
            }
        } else {
            setSearchResults([]);
        }
    }, []);

    const debouncedFetchResults = useRef(_.debounce((value) => {
        fetchResults(value);
    }, 1000)).current;

    const validateTag = (value, array) => {
        if (array === null)
            return false;
        for (const arrayFlag of array) {
            if (arrayFlag.toUpperCase().includes(value.toUpperCase())) {
                return true;
            }
        }
    }


    const handleChangeFilter = (event) => {
        const filter = event.target.value;
        if (filter.length > 0) {
            let arrayGroupFilter = [];

            for (const menusFilter of menuOriginal) {
                let groupFlag = { ...menusFilter, group: { ...menusFilter.group, sections: [], menus: [] } };
                let existe = false;

                if (menusFilter.group && menusFilter.group.sections) {
                    for (const section of menusFilter.group.sections) {
                        let filteredMenus = section.menus.filter(menuSection =>
                            menuSection.name.toUpperCase().includes(filter.toUpperCase()) || validateTag(filter, menuSection.tag)
                        );

                        if (filteredMenus.length > 0) {
                            existe = true;
                            groupFlag.group.sections.push({
                                ...section,
                                menus: filteredMenus
                            });
                        }
                    }
                }

                if (menusFilter.group && menusFilter.group.menus) {
                    let filteredGroupMenus = menusFilter.group.menus.filter(menuItem =>
                        menuItem.name.toUpperCase().includes(filter.toUpperCase()) || validateTag(filter, menuItem.tag)
                    );

                    if (filteredGroupMenus.length > 0) {
                        existe = true;
                        groupFlag.group.menus = filteredGroupMenus;
                    }
                }

                if (groupFlag.group.sections.length === 0) {
                    groupFlag.group.sections = null;
                }

                if (groupFlag.group.menus.length === 0) {
                    groupFlag.group.menus = null;
                }

                if (existe) {
                    arrayGroupFilter.push(groupFlag);
                }
            }
            setMenu(arrayGroupFilter);
            let objectMenu = {};
            for (const m of arrayGroupFilter) {
                let nameGroup = m.group.name;
                objectMenu[nameGroup] = true;
                if (m.group.sections) {
                    for (const sect of m.group.sections) {
                        let nameSection = `${nameGroup}_${sect.name}`;
                        objectMenu[nameSection] = true;
                    }
                }
            }
            setOpenMenu(objectMenu);
        } else {
            setMenu(menuOriginal);
            setOpenMenu({});
        }
    };

    const handleChange = (event) => {
        const inputValue = event.target.value;
        setSearchText(inputValue);
        debouncedFetchResults(inputValue);
    };

    const handleSelect = (result) => {
        setSearchText('');
        setSearchResults([]);
        navigate(`/${result.doc}?id=${result.id}&m=r`);
        window.location.reload();
        setIsResultsVisible(false);
    };

    const resultsContainerRef = useRef(null);

    const handleClickOutside = (event) => {
        if (resultsContainerRef.current && !resultsContainerRef.current.contains(event.target)) {
            setIsResultsVisible(false);
        }
    };

    const handleEscapePress = (event) => {
        if (event.key === 'Escape') {
            setIsResultsVisible(false);
        }
    };

    useEffect(() => {
        searchSourceField();
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscapePress);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscapePress);
        };
        // eslint-disable-next-line
    }, []);


    useEffect(() => {
        const user = AuthService.getCurrentUser();
        if (!user) {
            navigate('/');
        }
        setCurrentUser(user);
        if (user) {

            menuService.viewMenuGlobal(constants.CLIENT, user.data.instance).then((responseMenuGlobal) => {
                let setup = null;
                for (let i = 0; i < responseMenuGlobal.data.length; i++) {
                    if (responseMenuGlobal.data[i].id === '_setup') {
                        setup = responseMenuGlobal.data[i];
                    }
                }

                menuService.viewMenuFindByRole(constants.CLIENT, user.data.instance, user.data.role).then((responseMenu) => {
                    let arrayGroup = [];
                    responseMenu = responseMenu.data;
                    for (let i = 0; i < responseMenu.length; i++) {
                        for (let r = 0; r < responseMenu[i].menuType.length; r++) {
                            if (arrayGroup.length === 0 && responseMenu[i].menuType[r].type === roles.menuType && responseMenu[i].menuType[r].group !== null) {
                                if (responseMenu[i].menuType[r].section == null) {

                                    let orderGroup = 10000;
                                    let iconGroup = null;
                                    for (let j = 0; j < setup.group.length; j++) {
                                        if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                            orderGroup = setup.group[j].order;
                                            iconGroup = setup.group[j].icon;
                                        }
                                    }
                                    arrayGroup.push({
                                        'group': {
                                            'name': responseMenu[i].menuType[r].group,
                                            'order': orderGroup,
                                            'icon': iconGroup,
                                            'menus': [{
                                                'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                'route': responseMenu[i].route,
                                                'mode': responseMenu[i].menuType[r].mode,
                                                'order': responseMenu[i].menuType[r].order,
                                                'tag': responseMenu[i].menuType[r].tag,
                                            }]
                                        }
                                    })
                                } else {
                                    if (responseMenu[i].menuType[r].tab == null) {

                                        let orderGroup = 10000;
                                        let orderSection = 10000;
                                        let iconGroup = null;
                                        let iconSection = null;
                                        for (let j = 0; j < setup.group.length; j++) {
                                            if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                                orderGroup = setup.group[j].order;
                                                iconGroup = setup.group[j].icon;
                                            }
                                        }

                                        for (let j = 0; j < setup.section.length; j++) {
                                            if (responseMenu[i].menuType[r].section === setup.section[j].name) {
                                                orderSection = setup.section[j].order;
                                                iconSection = setup.section[j].icon;
                                            }
                                        }

                                        arrayGroup.push({
                                            'group': {
                                                'name': responseMenu[i].menuType[r].group,
                                                'order': orderGroup,
                                                'icon': iconGroup,
                                                'sections': [{
                                                    'name': responseMenu[i].menuType[r].section,
                                                    'order': orderSection,
                                                    'icon': iconSection,
                                                    'menus': [{
                                                        'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                        'route': responseMenu[i].route,
                                                        'mode': responseMenu[i].menuType[r].mode,
                                                        'order': responseMenu[i].menuType[r].order,
                                                        'tag': responseMenu[i].menuType[r].tag,

                                                    }]
                                                }]
                                            },
                                        })
                                    } else {
                                        let orderGroup = 10000;
                                        let orderSection = 10000;
                                        let orderTab = 10000;
                                        let iconGroup = null;
                                        let iconSection = null;
                                        let iconTab = null;
                                        for (let j = 0; j < setup.group.length; j++) {
                                            if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                                orderGroup = setup.group[j].order;
                                                iconGroup = setup.group[j].icon;
                                            }
                                        }

                                        for (let j = 0; j < setup.section.length; j++) {
                                            if (responseMenu[i].menuType[r].section === setup.section[j].name) {
                                                orderSection = setup.section[j].order;
                                                iconSection = setup.section[j].icon;
                                            }
                                        }

                                        for (let j = 0; j < setup.tab.length; j++) {
                                            if (responseMenu[i].menuType[r].tab === setup.tab[j].name) {
                                                orderTab = setup.tab[j].order;
                                                iconTab = setup.tab[j].icon;
                                            }
                                        }
                                        arrayGroup.push({
                                            'group': {
                                                'name': responseMenu[i].menuType[r].group,
                                                'order': orderGroup,
                                                'icon': iconGroup,
                                                'sections': [{
                                                    'name': responseMenu[i].menuType[r].section,
                                                    'order': orderSection,
                                                    'icon': iconSection,
                                                    'tabs': [{
                                                        'name': responseMenu[i].menuType[r].tab,
                                                        'order': orderTab,
                                                        'icon': iconTab,
                                                        'menus': [{
                                                            'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                            'route': responseMenu[i].route,
                                                            'mode': responseMenu[i].menuType[r].mode,
                                                            'order': responseMenu[i].menuType[r].order,
                                                            'tag': responseMenu[i].menuType[r].tag,
                                                        }]
                                                    }]
                                                }]
                                            },
                                        })
                                    }
                                }
                            }
                            else {
                                let existGroup = false;
                                let existSection = false;
                                let existTab = false;
                                if (responseMenu[i].menuType[r].type === roles.menuType && responseMenu[i].menuType[r].group !== null) {
                                    for (let g = 0; g < arrayGroup.length; g++) {
                                        if (arrayGroup[g].group.name === responseMenu[i].menuType[r].group) {
                                            existGroup = true;
                                            if (arrayGroup[g].group.sections) {
                                                for (let v = 0; v < arrayGroup[g].group.sections.length; v++) {
                                                    if (arrayGroup[g].group.sections[v].name === responseMenu[i].menuType[r].section) {
                                                        existSection = true;
                                                        if (arrayGroup[g].group.sections[v].tabs) {
                                                            for (let b = 0; b < arrayGroup[g].group.sections[v].tabs.length; b++) {
                                                                if (arrayGroup[g].group.sections[v].tabs[b].name === responseMenu[i].menuType[r].tab) {
                                                                    existTab = true;
                                                                    if (arrayGroup[g].group.sections[v].tabs[b].menus != null) {
                                                                        arrayGroup[g].group.sections[v].tabs[b].menus.push({
                                                                            'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                            'route': responseMenu[i].route,
                                                                            'mode': responseMenu[i].menuType[r].mode,
                                                                            'order': responseMenu[i].menuType[r].order
                                                                        });
                                                                    } else {
                                                                        arrayGroup[g].group.sections[v].tabs[b].menus = [{
                                                                            'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                            'route': responseMenu[i].route,
                                                                            'mode': responseMenu[i].menuType[r].mode,
                                                                            'order': responseMenu[i].menuType[r].order,
                                                                            'tag': responseMenu[i].menuType[r].tag,
                                                                        }]
                                                                    }
                                                                }
                                                            }
                                                            if (existTab === false && responseMenu[i].menuType[r].tab !== null) {

                                                                let orderGroup = 10000;
                                                                let iconGroup = null;
                                                                for (let j = 0; j < setup.group.length; j++) {
                                                                    if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                                                        orderGroup = setup.group[j].order;
                                                                        iconGroup = setup.group[j].icon;
                                                                    }
                                                                }

                                                                arrayGroup[g].group.sections[v].tabs.push({
                                                                    'name': responseMenu[i].menuType[r].tab,
                                                                    'order': orderGroup,
                                                                    'icon': iconGroup,
                                                                    'menus': {
                                                                        'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                        'route': responseMenu[i].route,
                                                                        'mode': responseMenu[i].menuType[r].mode,
                                                                        'order': responseMenu[i].menuType[r].order,
                                                                        'tag': responseMenu[i].menuType[r].tag,
                                                                    }
                                                                });
                                                            }
                                                        } else {
                                                            arrayGroup[g].group.sections[v].menus.push({
                                                                'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                'route': responseMenu[i].route,
                                                                'mode': responseMenu[i].menuType[r].mode,
                                                                'order': responseMenu[i].menuType[r].order,
                                                                'tag': responseMenu[i].menuType[r].tag,
                                                            });
                                                        }
                                                    }
                                                }
                                            }
                                            if (existSection === false && responseMenu[i].menuType[r].section !== null) {

                                                if (responseMenu[i].menuType[r].tab === null) {
                                                    let orderSection = 10000;
                                                    let iconSection = null;
                                                    for (let j = 0; j < setup.section.length; j++) {
                                                        if (responseMenu[i].menuType[r].section === setup.section[j].name) {
                                                            orderSection = setup.section[j].order;
                                                            iconSection = setup.section[j].icon;
                                                        }
                                                    }
                                                    if (arrayGroup[g].group.sections) {
                                                        arrayGroup[g].group.sections.push({
                                                            'name': responseMenu[i].menuType[r].section,
                                                            'order': orderSection,
                                                            'icon': iconSection,
                                                            'menus': [{
                                                                'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                'route': responseMenu[i].route,
                                                                'mode': responseMenu[i].menuType[r].mode,
                                                                'order': responseMenu[i].menuType[r].order,
                                                                'tag': responseMenu[i].menuType[r].tag,
                                                            }]
                                                        });
                                                    } else {
                                                        arrayGroup[g].group.sections = [{
                                                            'name': responseMenu[i].menuType[r].section,
                                                            'order': orderSection,
                                                            'icon': iconSection,
                                                            'menus': [{
                                                                'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                'route': responseMenu[i].route,
                                                                'mode': responseMenu[i].menuType[r].mode,
                                                                'order': responseMenu[i].menuType[r].order,
                                                                'tag': responseMenu[i].menuType[r].tag,
                                                            }]
                                                        }];
                                                    }
                                                }
                                            } else {
                                                if (responseMenu[i].menuType[r].section === null) {
                                                    if (arrayGroup[g].group.menus)
                                                        arrayGroup[g].group.menus.push({
                                                            'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                            'route': responseMenu[i].route,
                                                            'mode': responseMenu[i].menuType[r].mode,
                                                            'order': responseMenu[i].menuType[r].order,
                                                            'tag': responseMenu[i].menuType[r].tag,
                                                        })
                                                    else
                                                        arrayGroup[g].group.menus = [{
                                                            'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                            'route': responseMenu[i].route,
                                                            'mode': responseMenu[i].menuType[r].mode,
                                                            'order': responseMenu[i].menuType[r].order,
                                                            'tag': responseMenu[i].menuType[r].tag,
                                                        }]
                                                }
                                            }
                                        }
                                    }

                                    if (existGroup === false) {
                                        if (responseMenu[i].menuType[r].section == null) {

                                            let orderGroup = 10000;
                                            let iconGroup = null;
                                            for (let j = 0; j < setup.group.length; j++) {
                                                if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                                    orderGroup = setup.group[j].order;
                                                    iconGroup = setup.group[j].icon;
                                                }
                                            }

                                            arrayGroup.push({
                                                'group': {
                                                    'name': responseMenu[i].menuType[r].group,
                                                    'order': orderGroup,
                                                    'icon': iconGroup,
                                                    'menus': [{
                                                        'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                        'route': responseMenu[i].route,
                                                        'mode': responseMenu[i].menuType[r].mode,
                                                        'order': responseMenu[i].menuType[r].order,
                                                        'tag': responseMenu[i].menuType[r].tag,
                                                    }]
                                                }
                                            })
                                        } else {
                                            if (responseMenu[i].menuType[r].tab == null) {

                                                let orderGroup = 10000;
                                                let orderSection = 10000;
                                                let iconGroup = null;
                                                let iconSection = null;
                                                for (let j = 0; j < setup.group.length; j++) {
                                                    if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                                        orderGroup = setup.group[j].order;
                                                        iconGroup = setup.group[j].icon;
                                                    }
                                                }

                                                for (let j = 0; j < setup.section.length; j++) {
                                                    if (responseMenu[i].menuType[r].section === setup.section[j].name) {
                                                        orderSection = setup.section[j].order;
                                                        iconSection = setup.section[j].icon;
                                                    }
                                                }
                                                arrayGroup.push({
                                                    'group': {
                                                        'name': responseMenu[i].menuType[r].group,
                                                        'order': orderGroup,
                                                        'icon': iconGroup,
                                                        'sections': [{
                                                            'name': responseMenu[i].menuType[r].section,
                                                            'order': orderSection,
                                                            'icon': iconSection,
                                                            'menus': [{
                                                                'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                'route': responseMenu[i].route,
                                                                'mode': responseMenu[i].menuType[r].mode,
                                                                'order': responseMenu[i].menuType[r].order,
                                                                'tag': responseMenu[i].menuType[r].tag,
                                                            }]
                                                        }]
                                                    },
                                                })
                                            } else {
                                                let orderGroup = 10000;
                                                let orderSection = 10000;
                                                let orderTab = 10000;
                                                let iconGroup = null;
                                                let iconSection = null;
                                                let iconTab = null;

                                                for (let j = 0; j < setup.group.length; j++) {
                                                    if (responseMenu[i].menuType[r].group === setup.group[j].name) {
                                                        orderGroup = setup.group[j].order;
                                                        iconGroup = setup.group[j].icon;
                                                    }
                                                }

                                                for (let j = 0; j < setup.section.length; j++) {
                                                    if (responseMenu[i].menuType[r].section === setup.section[j].name) {
                                                        orderSection = setup.section[j].order;
                                                        iconSection = setup.section[j].icon;
                                                    }
                                                }

                                                for (let j = 0; j < setup.tab.length; j++) {
                                                    if (responseMenu[i].menuType[r].tab === setup.tab[j].name) {
                                                        orderTab = setup.tab[j].order;
                                                        iconTab = setup.tab[j].icon;
                                                    }
                                                }
                                                arrayGroup.push({
                                                    'group': {
                                                        'name': responseMenu[i].menuType[r].group,
                                                        'order': orderGroup,
                                                        'icon': iconGroup,
                                                        'sections': [{
                                                            'name': responseMenu[i].menuType[r].section,
                                                            'order': orderSection,
                                                            'icon': iconSection,
                                                            'tabs': [{
                                                                'name': responseMenu[i].menuType[r].tab,
                                                                'order': orderTab,
                                                                'icon': iconTab,
                                                                'menus': [{
                                                                    'name': responseMenu[i].menuType[r].name != null ? responseMenu[i].menuType[r].name : responseMenu[i].name,
                                                                    'route': responseMenu[i].route,
                                                                    'mode': responseMenu[i].menuType[r].mode,
                                                                    'order': responseMenu[i].menuType[r].order,
                                                                    'tag': responseMenu[i].menuType[r].tag,
                                                                }]
                                                            }]
                                                        }]
                                                    },
                                                })
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }

                    arrayGroup = orderArrayGroup(arrayGroup);

                    for (let m = 0; m < arrayGroup.length; m++) {
                        if (arrayGroup[m].group.menus) {
                            arrayGroup[m].group.menus = orderArray(arrayGroup[m].group.menus);
                        }
                        if (arrayGroup[m].group.sections) {
                            arrayGroup[m].group.sections = orderArray(arrayGroup[m].group.sections);
                            for (let f = 0; f < arrayGroup[m].group.sections.length; f++) {
                                if (arrayGroup[m].group.sections[f].menus)
                                    arrayGroup[m].group.sections[f].menus = orderArray(arrayGroup[m].group.sections[f].menus);

                                if (arrayGroup[m].group.sections[f].tabs) {
                                    arrayGroup[m].group.sections[f].tabs = orderArray(arrayGroup[m].group.sections[f].tabs);

                                    for (let a = 0; a < arrayGroup[m].group.sections[f].tabs.length; a++) {
                                        if (arrayGroup[m].group.sections[f].tabs[a].menus) {
                                            arrayGroup[m].group.sections[f].tabs[a].menus = orderArray(arrayGroup[m].group.sections[f].tabs[a].menus);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    setMenuOriginal(arrayGroup);
                    setMenu(arrayGroup);

                    for (var r = 0; r < arrayGroup.length; r++) {
                        let field = arrayGroup[r].group.name;

                        setOpenMenu(prevState => ({
                            ...prevState,
                            [field]: false
                        }), []);
                        if (arrayGroup[r].group.sections) {
                            for (var l = 0; l < arrayGroup[r].group.sections.length; l++) {
                                let fieldSection = `${arrayGroup[r].group.name}_${arrayGroup[r].group.sections[l].name}`;
                                setOpenMenu(prevState => ({
                                    ...prevState,
                                    [fieldSection]: false
                                }), []);
                                if (arrayGroup[r].group.sections[l].tabs) {
                                    for (var g = 0; g < arrayGroup[r].group.sections[l].tabs.length; g++) {
                                        let fieldTab = `${arrayGroup[r].group.name}_${arrayGroup[r].group.sections[l].tabs[g].name}`;
                                        setOpenMenu(prevState => ({
                                            ...prevState,
                                            [fieldTab]: false
                                        }), []);
                                    }
                                }
                            }
                        }
                    }
                    setIsLoad(true);
                }).catch((error) => {
                    console.log(error);
                });
            }).catch((error) => {
                console.log(error);
            });
        }

    }, [navigate]);

    const filterByTradeAccountIdManagerIdFindSourceField = () => {
        const user = AuthService.getCurrentUser();
        let whereFieldParam = [];
        if (user.data.companyId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'companyId') {
                    existe = true;
                    item.value = user.data.companyId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'companyId',
                    operator: '=',
                    value: user.data.companyId
                })
            }
        }

        if (user.data.tradeAccountId) {
            let existe = false;
            whereFieldParam.forEach((item) => {
                if (item.idField === 'tradeAccountId') {
                    existe = true;
                    item.value = user.data.tradeAccountId
                }
            })
            if (existe === false) {
                whereFieldParam.push({
                    idField: 'tradeAccountId',
                    operator: '=',
                    value: user.data.tradeAccountId
                })
            }
        } else {
            if (user.data.isManager === '1') {
                let existe = false;
                whereFieldParam.forEach((item) => {
                    if (item.idField === 'managerId') {
                        existe = true;
                        item.value = user.data.managerId
                    }
                })
                if (existe === false) {
                    whereFieldParam.push({
                        idField: 'managerId',
                        operator: '=',
                        value: user.data.managerId
                    })
                }
            }
        }
        return whereFieldParam;
    }

    const searchSourceField = () => {
        let whereFilters = filterByTradeAccountIdManagerIdFindSourceField();
        const user = AuthService.getCurrentUser();
        const arrayTables = [{
            table: `${user.data.instance}.tradeAccount`,
            doc: [],
            selectFilters: ['managerId'],
            whereFilters: whereFilters
        }, {
            table: `${user.data.instance}.manager`,
            doc: [],
            selectFilters: [],
            whereFilters: whereFilters
        }]

        informationService.findSourceField(arrayTables).then((response) => {

            let opcComitentes = [];
            let opcManager = [];
            for (let t = 0; t < response.data.length; t++) {
                if (response.data[t].source === 'tradeAccount' && response.data[t].isInactive === '0') {
                    opcComitentes.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                        managerId: response.data[t].managerId
                    })
                }
                if (response.data[t].source === 'manager' && response.data[t].isInactive === '0') {
                    opcManager.push({
                        id: response.data[t].id,
                        label: (response.data[t].nameAlt !== undefined && response.data[t].nameAlt !== '') ? `${response.data[t].name} ${response.data[t].nameAlt}` : `${response.data[t].name}`,
                        isInactive: response.data[t].isInactive,
                    })
                }
            }

            let managerId = 0;
            if (user.data.isManager === '1') {
                /*setFilterManager({
                    id: user.data.managerId,
                    label: user.data.manager,
                    isInactive: 0,
                });*/
                managerId = user.data.managerId;
            }
            if (user.data.tradeAccountId && user.data.managerId) {
                /*setFilterComitente({
                    id: user.data.tradeAccountId,
                    label: user.data.tradeAccount,
                    isInactive: 0,
                })*/
            }
            if (managerId > 0) {
                let arrayOptCom = [];
                for (let g = 0; g < opcComitentes.length; g++) {
                    if (Number(opcComitentes[g].managerId) === Number(managerId)) {
                        arrayOptCom.push(opcComitentes[g]);
                    }
                }
                setOptionsComitentes(arrayOptCom);
            } else {
                setOptionsComitentes(opcComitentes);
            }
            /*setOptionsComitentesOriginales(opcComitentes);
            setOptionsManager(opcManager);

            setLoadSubtotalesCards(true);*/
            setValidateComitente(true);
        })
    }

    const handleClick = (field, sections) => {

        if (sections) {
            sections.forEach((itemSections) => {
                let fieldSection = `${field}_${itemSections.name}`;
                if (openMenu[fieldSection] === true)
                    setOpenMenu(prevState => ({
                        ...prevState,
                        [fieldSection]: !openMenu[fieldSection]
                    }), []);
            })
        }

        setOpenMenu(prevState => ({
            ...prevState,
            [field]: !openMenu[field]
        }), []);

    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    const orderArray = array => {
        let temporal = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 1; j < (array.length - i); j++) {
                if (array[j - 1].order > array[j].order) {
                    temporal = array[j - 1];
                    array[j - 1] = array[j];
                    array[j] = temporal;
                }
            }
        }
        return array;
    }

    const orderArrayGroup = array => {
        let temporal = 0;
        for (let i = 0; i < array.length; i++) {
            for (let j = 1; j < (array.length - i); j++) {
                if (array[j - 1].group.order > array[j].group.order) {
                    temporal = array[j - 1];
                    array[j - 1] = array[j];
                    array[j] = temporal;
                }
            }
        }
        return array;
    }

    const handleMenu = (route, mode) => {
        navigate(`${route}?m=${mode}`);
        window.location.reload();
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const logOut = () => {

        const user = AuthService.getCurrentUser();
        AuthService.logout(user.email, user.data.instance, user.data.entityId).then(
            () => {
                navigate('/');
                window.location.reload();
            },
            (error) => {

            }
        );
    };

    const menuId = 'primary-search-account-menu';

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={logOut}>
                <ListItemIcon>
                    <Logout fontSize="small" />
                </ListItemIcon>
                Logout
            </MenuItem>
            <Divider />

            <MenuItem onClick={handleMenuClose}>
                <Avatar />{currentUser.data && currentUser.data.role}
            </MenuItem>

            <Divider />
            <MenuItem onClick={handleMenuClose}>
                <ListItemIcon>
                    <Settings fontSize="small" />
                </ListItemIcon>
                Instancia: {currentUser.data && currentUser.data.instance}
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleMenuClose}>
                <ListItemIcon>
                    <Settings fontSize="small" />
                </ListItemIcon>
                Perfil: {currentUser.data && (currentUser.data.entityProp)}
            </MenuItem>
            <Divider />
            {/*<MenuItem onClick={handleMenuClose}>
                <ListItemIcon>
                    <Settings fontSize="small" />
                </ListItemIcon>
                Cuenta Comitente:  {currentUser.data && (currentUser.data.tradeAccount)}
            </MenuItem>*/}
        </Menu>
    );

    const matchingInstance = currentUser.instances?.find(instance => instance.name === currentUser.data.instance);

    const security = (item) => {

        for (const rolFlag of roles.current) {

            if (rolFlag.name === item.route.replace('/', '')) {
                switch (rolFlag.level) {
                    case 'full':
                        return true;
                    case 'edit':
                        return true;
                    default:
                        return false
                }
            }
        }
        return false;
    }

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar sx={{ backgroundColor: 'rgb(50 59 152)' }} position="fixed" open={open}>
                <Toolbar>


                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleOpenAndFocus}
                        edge="start"
                        sx={{ mr: 2, ...(open && { display: 'none' }) }}
                        style={{ marginRight: '0px', paddingRight: '0px' }}
                    >
                        <MenuIcon />
                    </IconButton>
                    {currentUser.data && !open && (
                        <img alt="" onClick={() => window.open((currentUser.data.landingPage !== null && currentUser.data.landingPage !== undefined) ? `${window.location.origin}/${currentUser.data.landingPage}` : `${window.location.origin}/home`, '_blank')} src={`${imageUrl}${currentUser.data.instance}.png`} />
                    )}
                    {/*<Search>
                        <SearchIconWrapper>
                            <SearchIcon />
                        </SearchIconWrapper>
                        <StyledInputBase
                            placeholder="Buscar..."
                            inputProps={{ 'aria-label': 'search' }}
                            value={searchText}
                            onChange={handleChange}
                        />

                    </Search>*/}
                    {isResultsVisible && (isLoading || searchResults.length > 0) && (
                        <ResultsContainer ref={resultsContainerRef}>
                            {isLoading ? (
                                <MenuItem disabled>Cargando...</MenuItem>
                            ) : (
                                searchResults.map((result, index) => (
                                    <CustomMenuItem key={index}
                                        onClick={(event) => {
                                            event.stopPropagation();
                                            handleSelect(result);
                                        }}
                                    >
                                        {result.title} - {result.docName}
                                    </CustomMenuItem>
                                ))
                            )}
                            {!isLoading && searchResults.length === 0 && (
                                <CustomMenuItem disabled>No hay resultados</CustomMenuItem>
                            )}
                        </ResultsContainer>
                    )}
                    <Box sx={{ flexGrow: 1 }} />
                    {currentUser.data && (
                        <>
                            {currentUser.data.isManager === '1' && (
                                <Box sx={{ minWidth: 250, maxWidth: 300, flex: 1, paddingRight: '30px', height: '100%' }}>
                                    <Autocomplete sx={{ backgroundColor: 'rgba(255, 255, 255, 0.15)' }}
                                        options={optionsComitentes}
                                        getOptionLabel={(option) => option.label}
                                        value={filterComitente}
                                        onChange={handleChangeComitente}
                                        inputValue={inputValueComitente}
                                        onInputChange={handleInputChangeComitente}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        //disabled={(currentUser.data.managerId && currentUser.data.tradeAccountId) ? true : false}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Cuenta Comitente"
                                                variant="outlined"
                                                sx={{
                                                    '& .MuiInputBase-root': {
                                                        color: 'white',
                                                        height: '39px',
                                                        minHeight: 32,
                                                        paddingRight: '8px',
                                                        fontSize: "inherit",
                                                        fontWeight: '600',
                                                        lineHeight: "inherit",
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        color: 'white',
                                                        padding: '0 8px',
                                                        fontSize: "inherit",
                                                        fontWeight: '600',
                                                        lineHeight: "inherit",
                                                    },
                                                    '& .MuiInputLabel-root': {
                                                        color: 'white',
                                                        fontSize: "inherit",
                                                        fontWeight: '600',
                                                        top: '-4px',
                                                    },

                                                    '& .MuiInputLabel-shrink': {
                                                        transform: 'translate(14px, -3px) scale(0.58)',
                                                    },
                                                    '& .MuiOutlinedInput-notchedOutline legend': {
                                                        maxWidth: 0,
                                                    },
                                                    '& .Mui-focused .MuiOutlinedInput-notchedOutline legend': {
                                                        maxWidth: 2500,
                                                    }
                                                }}
                                            />
                                        )}
                                        fullWidth
                                        slotProps={{
                                            popper: {
                                                sx: {
                                                    '& .MuiAutocomplete-option': {
                                                        fontSize: 'inherit',
                                                    }
                                                }
                                            }
                                        }}
                                    />
                                </Box>
                            )}
                            <span onClick={handleClickCuentaComitente} style={{ /*font: "Exo2Regular",*/fontSize: "inherit", lineHeight: "inherit", cursor: 'pointer' }}>
                                {currentUser.data.tradeAccount ? `${currentUser.data.entityProperty} ${currentUser.data.entityProp}` : `${currentUser.data.entityProperty} ${currentUser.data.entityProp}`}
                            </span>
                            <Menu
                                anchorEl={anchorElCuentaComitente}
                                open={Boolean(anchorElCuentaComitente)}
                                onClose={handleCloseCuentaComitente}
                            >
                                {matchingInstance?.roles?.map((role, index) => {
                                    if (role.loginaccess === '1') {
                                        return <MenuItem key={index} onClick={() => handleSelectCuentaComitente(role, currentUser.data.instance)}>
                                            {role.tradeAccount ? `${role.entityProperty} ${role.entityProp}` : `${role.entityProperty} ${role.entityProp} (${role.role})`}
                                        </MenuItem>
                                    }
                                })}
                            </Menu>
                        </>
                    )}
                    <AddAlertIcon />
                    <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={menuId}
                        aria-haspopup="true"
                        onClick={handleProfileMenuOpen}
                        color="inherit"
                    >
                        <AccountCircle />
                        <div>{currentUser.username}</div>
                    </IconButton>

                </Toolbar>

            </AppBar>
            <Drawer
                sx={{
                    width: drawerWidth,
                    flexShrink: 0,
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        boxSizing: 'border-box',
                    },
                }}
                variant="persistent"
                anchor="left"
                open={open}
            >
                <DrawerHeader>
                    <Box sx={{ paddingTop: '20px', paddingBottom: '5px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                        {!isLoad && (
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <CircularProgress size={40} />
                            </div>
                        )}
                        {isLoad && (
                            <TextField
                                inputRef={inputRef}
                                variant="outlined"
                                size="small"
                                onChange={handleChangeFilter}
                                sx={{ marginRight: 'auto' }}
                            />
                        )}
                        <IconButton onClick={handleDrawerClose}>
                            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                        </IconButton>
                    </Box>
                </DrawerHeader>
                <Divider />
                <List>
                    {menu.map((item, index) => {
                        if (!item.group.sections) {
                            return <Fragment key={index}><ListItem disablePadding>
                                <ListItemButton onClick={() => handleClick(item.group.name, null)}>
                                    <ListItemIcon>
                                        {
                                            <Icons iconName={item.group.icon} />
                                        }
                                    </ListItemIcon>
                                    <ListItemText primary={item.group.name} />
                                    {openMenu[item.group.name] ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                            </ListItem>
                                {item.group.menus.map((itemMenu, indexMenu) => {
                                    return <Collapse in={openMenu[item.group.name]} key={indexMenu} timeout="auto" unmountOnExit>
                                        <ListItem
                                            secondaryAction={
                                                itemMenu.mode.length > 1 && security(itemMenu) ? <IconButton onClick={() => handleMenu(itemMenu.route, 'c')}>
                                                    <AddIcon />
                                                </IconButton> : ''
                                            }
                                            component="div"
                                            disablePadding>
                                            <ListItemButton sx={{ pl: 12 }} onClick={() => handleMenu(itemMenu.route, 'l')}>
                                                <ListItemText primary={itemMenu.name} />
                                            </ListItemButton>
                                        </ListItem>
                                    </Collapse>
                                })}
                            </Fragment >
                        } else {
                            if (item.group.sections[0].tabs) {
                                return <Fragment key={index}>
                                    <ListItem disablePadding>
                                        <ListItemButton onClick={() => handleClick(item.group.name, null)}>
                                            <ListItemIcon>
                                                {
                                                    <Icons iconName={item.group.icon} />
                                                }
                                            </ListItemIcon>
                                            <ListItemText primary={item.group.name} />
                                            {openMenu[item.group.name] ? <ExpandLess /> : <ExpandMore />}
                                        </ListItemButton>
                                    </ListItem>
                                    <Collapse in={openMenu[item.group.name]} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton sx={{ pl: 4 }} onClick={() => handleClick(`${item.group.name}_${item.group.sections[0].name}`, null)}>
                                                <ListItemIcon>
                                                    <StarBorder />
                                                </ListItemIcon>
                                                <ListItemText primary={item.group.sections[0].name} />
                                                {openMenu[`${item.group.name}_${item.group.sections[0].name}`] ? <ExpandLess /> : <ExpandMore />}
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                    <Collapse in={openMenu[`${item.group.name}_${item.group.sections[0].name}`]} timeout="auto" unmountOnExit>
                                        <List component="div" disablePadding>
                                            <ListItemButton sx={{ pl: 6 }} onClick={() => handleClick(`${item.group.name}_${item.group.sections[0].tabs[0].name}`, null)}>
                                                <ListItemIcon>
                                                    <StarBorder />
                                                </ListItemIcon>
                                                <ListItemText primary={item.group.sections[0].tabs[0].name} />
                                                {openMenu[`${item.group.name}_${item.group.sections[0].tabs[0].name}`] ? <ExpandLess /> : <ExpandMore />}
                                            </ListItemButton>
                                        </List>
                                    </Collapse>
                                    {item.group.sections[0].tabs[0].menus.map((itemMenu, indexMenu) => {
                                        return <Collapse in={openMenu[`${item.group.name}_${item.group.sections[0].tabs[0].name}`]} key={indexMenu} timeout="auto" unmountOnExit>
                                            <ListItem
                                                key={index}
                                                secondaryAction={
                                                    itemMenu.mode.length > 1 && security(itemMenu) ? <IconButton onClick={() => handleMenu(itemMenu.route, 'c')}>
                                                        <AddIcon />
                                                    </IconButton> : ''
                                                }
                                                component="div"
                                                disablePadding>
                                                <ListItemButton sx={{ pl: 12 }} onClick={() => handleMenu(itemMenu.route, 'l')}>
                                                    <ListItemText primary={itemMenu.name} />
                                                </ListItemButton>
                                            </ListItem>
                                        </Collapse>
                                    })}
                                </Fragment>
                            } else {
                                return <Fragment key={index}><ListItem disablePadding>
                                    <ListItemButton onClick={() => handleClick(item.group.name, item.group.sections)}>
                                        <ListItemIcon>
                                            {/*index % 2 === 0 ? <InboxIcon /> : <MailIcon />*/}
                                            {
                                                <Icons iconName={item.group.icon} />
                                            }

                                        </ListItemIcon>
                                        <ListItemText primary={item.group.name} />
                                        {openMenu[item.group.name] ? <ExpandLess /> : <ExpandMore />}
                                    </ListItemButton>
                                </ListItem>


                                    {
                                        item.group.menus && (
                                            item.group.menus.map((itemMenu, indexMenu) => {
                                                return <Collapse in={openMenu[item.group.name]} key={indexMenu} timeout="auto" unmountOnExit>
                                                    <ListItem
                                                        secondaryAction={
                                                            itemMenu.mode.length > 1 && security(itemMenu) ? <IconButton onClick={() => handleMenu(itemMenu.route, 'c')}>
                                                                <AddIcon />
                                                            </IconButton> : ''
                                                        }
                                                        component="div"
                                                        disablePadding>
                                                        <ListItemButton sx={{ pl: 12 }} onClick={() => handleMenu(itemMenu.route, 'l')}>
                                                            <ListItemText primary={itemMenu.name} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                </Collapse>
                                            })
                                        )
                                    }


                                    {item.group.sections.map((itemSections) => {
                                        return <div key={itemSections.name}>
                                            <Collapse in={openMenu[item.group.name]} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding>
                                                    <ListItemButton sx={{ pl: 4 }} onClick={() => handleClick(`${item.group.name}_${itemSections.name}`, null)}>
                                                        <ListItemIcon>
                                                            {
                                                                <Icons iconName={itemSections.icon} />
                                                            }
                                                        </ListItemIcon>
                                                        <ListItemText primary={itemSections.name} />
                                                        {openMenu[`${item.group.name}_${itemSections.name}`] ? <ExpandLess /> : <ExpandMore />}
                                                    </ListItemButton>
                                                </List>
                                            </Collapse>



                                            {
                                                itemSections.menus.map((itemMenu, indexMenu) => {
                                                    return < Collapse in={openMenu[`${item.group.name}_${itemSections.name}`]} key={indexMenu} timeout="auto" unmountOnExit>
                                                        <ListItem
                                                            secondaryAction={
                                                                itemMenu.mode.length > 1 && security(itemMenu) ? <IconButton onClick={() => handleMenu(itemMenu.route, 'c')}>
                                                                    <AddIcon />
                                                                </IconButton> : ''
                                                            }
                                                            component="div"
                                                            disablePadding>
                                                            <ListItemButton sx={{ pl: 12 }} onClick={() => handleMenu(itemMenu.route, 'l')}>
                                                                <ListItemText primary={itemMenu.name} />
                                                            </ListItemButton>
                                                        </ListItem>
                                                    </Collapse>
                                                })
                                            }
                                        </div>
                                    })
                                    }
                                </Fragment>
                            }
                        }
                    })}
                </List>

            </Drawer>
            {renderMenu}
        </Box >
    );
}

export default PersistentDrawerLeft;